import { RootState } from '../root-reducer';

export const getTemplates = (state: RootState) => {
  return state.userprofile.templates;
};

export const getShipmentIds = (state: RootState) => {
  return state.userprofile && state.userprofile.shipmentIds;
};
